import { createSelector } from 'redux-starter-kit'

import { FETCH_SHOWCASE_SUCCESS } from 'Catalog/Showcase/ducks'
import { FETCH_SEARCH_SUCCESS } from 'Catalog/Search/ducks'

export const FETCH_AVAILABILITY = 'availability/FETCH'
export const FETCH_AVAILABILITY_SUCCESS = 'availability/FETCH_SUCCESS'
export const FETCH_AVAILABILITY_FAIL = 'availability/FETCH_FAIL'

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_AVAILABILITY:
      return {
        ...state,
        [action.sku]: {
          ...state[action.sku],
          isLoading: true
        }
      }
    case FETCH_AVAILABILITY_SUCCESS:
      var { available: isAvailable, ...price } = action.payload.data[0]

      return {
        ...state,
        [action.meta.previousAction.sku]: {
          isLoading: false,
          isAvailable,
          isPriceUpdated: true,
          ...(isAvailable && { price })
        }
      }
    case FETCH_AVAILABILITY_FAIL:
      return {
        ...state,
        [action.meta.previousAction.sku]: {
          isLoading: false,
          isAvailable: false,
          isPriceUpdated: true
        }
      }
    case FETCH_SHOWCASE_SUCCESS:
    case FETCH_SEARCH_SUCCESS:
      var hotAvailabilities = action.payload.data.products.reduce(
        (availabilities, currentProduct) => {
          const { sku, availability, hasPriceUpdated: isPriceUpdated } = currentProduct
          const { available: isAvailable, pointCash: pointsCash, ...price } = availability || {}

          const curAvailability = {
            [sku]: {
              ...state[sku],
              isLoading: false,
              isAvailable: isAvailable !== undefined ? isAvailable : state[sku] ? state[sku].isAvailable : false,
              isPriceUpdated,
              price: isAvailable ? { ...price, pointsCash } : state[sku] ? state[sku].price : undefined
            }
          }

          return { ...availabilities, ...curAvailability }
        }, {})
      return { ...state, ...hotAvailabilities }
    default:
      return { ...state }
  }
}

export const fetchAvailability = (sku, originalId, vendorId) => ({
  type: FETCH_AVAILABILITY,
  sku,
  payload: {
    client: 'availability',
    request: {
      method: 'GET',
      url: `/v1/products/skus/${sku}/availability`,
      params: { vendorId, originalId }
    }
  }
})

export const selectAvailabilityBySku = createSelector(
  [
    (state) => state.availability,
    (_, props) => props.sku
  ],
  (availability, sku) => availability[sku] && availability[sku]
)

export const selectIsAvailableBySku = createSelector(
  [selectAvailabilityBySku],
  (availability) => availability && availability.isAvailable
)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/ducks.js